<template>
	<Flex center :class="{ overlay: true, active: value }">
		<div>
			<slot/>
		</div>
	</Flex>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import Flex from '@/components/layout/Flex.vue'

export default defineComponent({
	name: 'Overlay',

	components: {
		Flex
	},

	props: {
		value: Boolean 
	}
})
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
	display: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); 
  z-index: 99;

	&.active {
		display: flex;
	}
}
</style>